module.exports = __webpack_public_path__ + "img/daren_11.45bb0d63.png";